import React from 'react';
import {
  Create,
  Toolbar,
  useNotify,
  useRedirect,
  useRefresh,
} from 'react-admin';
import { ManualReservationForm } from './ManualReservationForm';

export const ManualReservationCreate = (props: any) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();

  const validateManualReservationCreation = (values: any) => {
    const errors = {
      ...([
        'service',
        'service_city',
        'status',
        'reservor_id',
        'starts_at',
        'duration_estimate',
        'departure_address',
        'destination_address',
        'price_estimate',
      ]
        .filter((v) => !values[v])
        .reduce((accumulator: any, value: any) => {
          accumulator[value] = `${value} is required`;
          return accumulator;
        }, {}) || {}),
    };

    return errors;
  };

  const onSuccess = (data: any) => {
    notify(`Changes saved`, { type: 'success' });
    redirect(`/manual_reservation/${data.data.id}`);
    refresh();
  };

  return (
    <Create onSuccess={onSuccess} {...props}>
      <ManualReservationForm
        {...props}
        validate={validateManualReservationCreation}
        submitOnEnter={false}
        toolbar={
          <Toolbar
            //@ts-ignore
            alwaysEnableSaveButton={() =>
              validateManualReservationCreation(props.record)
            }
          />
        }
      />
    </Create>
  );
};
